// PRD.316 — PowerSync queries for Clinical Findings.
//
// Kept separate from `clinical-findings-logic.ts` (vocabulary, suggestion
// derivation, formatting) because that module must stay import-free to run
// under the node:test harness. Everything from there is re-exported here so
// callers have one entry point.

import type { QuerySpec } from '@helios/powersync-client-core';

export * from './clinical-findings-logic.js';

/**
 * Every finding on one encounter.
 *
 * Ordering is applied by `sortFindings` rather than in SQL, so the same
 * sort_order → created_at rule holds for rows that arrive mid-session from a
 * sync round-trip.
 */
export function qClinicalFindingsByEncounter(encounterId: string): QuerySpec<[string]> {
  return {
    key: ['encounter_clinical_findings', 'by-encounter', encounterId] as const,
    sql: `SELECT * FROM encounter_clinical_findings WHERE encounter_id = ?`,
    params: [encounterId],
    watch: ['encounter_clinical_findings'],
  };
}
